import { Redirect } from 'expo-router'

export default function DealTheFlopEmbeddedRedirect() {
  return <Redirect href="/game/deal-the-flop" />
}
